import { PayrollRun, PayrollRunStatus } from "@wingspanhq/wingspan-api-sdk";

const MS_PER_DAY = 1000 * 60 * 60 * 24;

type WorklogApprovalWindow = {
  /** Set only while the window is still open; drives the warning alert. */
  dueDate?: Date;
  daysLeft?: number;
};

/**
 * The run's open worklog-approval window, from `approvalDeadline`.
 *
 * The alert this drives only applies while the run can still change — once it
 * is finalized, paid, cancelled or failed, unapproved work logs can no longer
 * join it, so the window reads as closed.
 */
export const selectorPayrollRunWorklogApproval = (
  payrollRun: PayrollRun
): WorklogApprovalWindow => {
  const isApprovalWindowOpen =
    payrollRun.status === PayrollRunStatus.DRAFT ||
    payrollRun.status === PayrollRunStatus.PENDING_APPROVALS;
  const dueDate = payrollRun.approvalDeadline ?? undefined;

  if (!isApprovalWindowOpen || !dueDate) {
    return {};
  }

  return {
    dueDate,
    daysLeft: Math.max(
      Math.ceil((dueDate.getTime() - Date.now()) / MS_PER_DAY),
      0
    )
  };
};
